import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import Home from './components/Home';


import HomePage from './pages/HomePage';
import GoldSilverWebsite from './pages/Home2';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import AboutUs from './pages/AboutPage';




function App() {
  return (
    <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/soon" element={<HomePage />} />
          <Route path="/" element={<GoldSilverWebsite />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUs />} />




        </Routes>
    </Router>
   
  );
}

export default App;
